import React from 'react';

import type { EmojiProvider } from '@atlaskit/emoji/resource';

import type { PublishedConfluenceData } from '../../../common/types';

import { ConfluenceDetails } from './confluence-details';

export const DetailsRow = ({
	publishedContentData,
	emojiProvider,
	product,
	cloudId,
}: {
	publishedContentData: PublishedConfluenceData | undefined;
	emojiProvider?: Promise<EmojiProvider>;
	product: string;
	cloudId: string;
}): React.JSX.Element | null => {
	if (!publishedContentData) {
		return null;
	}

	if (product === 'confluence') {
		return (
			<>
				<ConfluenceDetails
					publishedContentData={publishedContentData}
					emojiProvider={emojiProvider}
					cloudId={cloudId}
				/>
			</>
		);
	}

	return null;
};
